var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustomers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 105,
    viewBox: "0 0 127 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.71509 99.836C7.9835 101.911 9.88446 103.523 12.1381 104.436C12.7462 102.057 12.4369 99.5368 11.2717 97.3757C10.1065 95.2146 8.17065 93.5711 5.84909 92.772C5.37318 95.1586 5.67677 97.635 6.71509 99.836V99.836Z",
    fill: "#11376A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.90897 98.7771C9.92264 100.141 11.4451 102.116 12.252 104.41C9.84727 104.906 7.34416 104.478 5.2403 103.212C3.13643 101.947 1.58591 99.9356 0.896973 97.5791C3.30229 97.2169 5.76032 97.6369 7.90897 98.7771V98.7771Z",
    fill: "#1897CD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2061 5.25806H58.6431V5.53706H78.2061V5.25806Z",
    fill: "#F2F2F2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8962 5.46704H72.6172V8.05204H72.8962V5.46704Z",
    fill: "#F2F2F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3718 5.46704H64.0928V8.05204H64.3718V5.46704Z",
    fill: "#F2F2F2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1279 18.672H68.5649V18.951H88.1279V18.672Z",
    fill: "#F2F2F2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M74.154 16.157H73.875V18.742H74.154V16.157Z",
    fill: "#F2F2F2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6779 16.157H82.3989V18.742H82.6779V16.157Z",
    fill: "#F2F2F2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M114.119 24.9611H94.5562V25.2401H114.119V24.9611Z",
    fill: "#F2F2F2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M100.145 22.4449H99.8662V25.0299H100.145V22.4449Z",
    fill: "#F2F2F2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M108.669 22.4449H108.39V25.0299H108.669V22.4449Z",
    fill: "#F2F2F2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M112.162 89.799H92.5991V90.078H112.162V89.799Z",
    fill: "#F2F2F2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1882 87.283H97.9092V89.868H98.1882V87.283Z",
    fill: "#F2F2F2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M106.712 87.283H106.433V89.868H106.712V87.283Z",
    fill: "#F2F2F2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7651 44.943H59.2021V45.222H78.7651V44.943Z",
    fill: "#F2F2F2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7912 42.428H64.5122V45.013H64.7912V42.428Z",
    fill: "#F2F2F2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3151 42.428H73.0361V45.013H73.3151V42.428Z",
    fill: "#F2F2F2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9141 78.62H65.3511V78.899H84.9141V78.62Z",
    fill: "#F2F2F2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9401 76.104H70.6611V78.689H70.9401V76.104Z",
    fill: "#F2F2F2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4641 76.104H79.1851V78.689H79.4641V76.104Z",
    fill: "#F2F2F2"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M116.215 68.4189H96.6519V68.6979H116.215V68.4189Z",
    fill: "#F2F2F2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M102.241 65.9041H101.962V68.4891H102.241V65.9041Z",
    fill: "#F2F2F2"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M110.765 65.9041H110.486V68.4891H110.765V65.9041Z",
    fill: "#F2F2F2"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4899 98.361H18.4019V98.123H51.2518V86.5779H21.1839L19.7229 83.535L19.9379 83.4349L21.3379 86.343H51.4939L51.4899 98.361Z",
    fill: "#11376A"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8061 104.192C24.1863 104.192 25.3051 103.073 25.3051 101.693C25.3051 100.313 24.1863 99.194 22.8061 99.194C21.426 99.194 20.3071 100.313 20.3071 101.693C20.3071 103.073 21.426 104.192 22.8061 104.192Z",
    fill: "#11376A"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4428 104.192C48.823 104.192 49.9418 103.073 49.9418 101.693C49.9418 100.313 48.823 99.194 47.4428 99.194C46.0627 99.194 44.9438 100.313 44.9438 101.693C44.9438 103.073 46.0627 104.192 47.4428 104.192Z",
    fill: "#11376A"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M76.484 50.157C77.3384 50.157 78.031 49.4644 78.031 48.61C78.031 47.7556 77.3384 47.063 76.484 47.063C75.6296 47.063 74.937 47.7556 74.937 48.61C74.937 49.4644 75.6296 50.157 76.484 50.157Z",
    fill: "#11376A"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0299 82.6509H17.8429L9.7959 56.351H63.3219L63.2729 56.506L55.0299 82.6509ZM18.0149 82.4129H54.8549L62.9929 56.585H10.1129L18.0149 82.4129Z",
    fill: "#11376A"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1261 81.282H19.4601L12.3921 57.954H59.4051L59.3621 58.091L52.1261 81.282Z",
    fill: "#F2F2F2"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9829 53.997L63.7529 53.936L65.3239 48.015H74.4609V48.253H65.5069L63.9829 53.997Z",
    fill: "#11376A"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6421 64.321H12.3921V64.559H60.6421V64.321Z",
    fill: "#11376A"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8792 73.0911H15.0752V73.3291H57.8792V73.0911Z",
    fill: "#11376A"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6721 56.4661H36.4341V82.5321H36.6721V56.4661Z",
    fill: "#11376A"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M47.319 56.4553L45.6211 82.524L45.8586 82.5395L47.5565 56.4708L47.319 56.4553Z",
    fill: "#11376A"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7814 56.4575L25.5439 56.473L27.2428 82.5387L27.4803 82.5232L25.7814 56.4575Z",
    fill: "#11376A"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M126.102 104.344H0.896973V104.623H126.102V104.344Z",
    fill: "#2F2E41"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0981 8.88606C84.0981 8.88606 86.1412 14.7001 84.8842 15.5941C83.6272 16.4881 89.1271 23.7941 89.1271 23.7941L95.7271 22.0051L92.1132 15.8931C92.1132 15.8931 91.6422 9.78106 91.6422 8.88606C91.6422 7.99106 84.0981 8.88606 84.0981 8.88606Z",
    fill: "#A0616A"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M84.0981 8.88606C84.0981 8.88606 86.1412 14.7001 84.8842 15.5941C83.6272 16.4881 89.1271 23.7941 89.1271 23.7941L95.7271 22.0051L92.1132 15.8931C92.1132 15.8931 91.6422 9.78106 91.6422 8.88606C91.6422 7.99106 84.0981 8.88606 84.0981 8.88606Z",
    fill: "black"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M80.669 50.332C80.669 50.332 80.069 57.786 80.669 61.662C81.269 65.538 82.16 76.271 82.16 76.271C82.16 76.271 82.16 96.545 85.44 96.843C88.72 97.141 91.105 97.443 91.403 96.243C91.701 95.043 89.912 94.454 90.803 93.858C91.694 93.262 91.996 91.175 90.803 88.789C89.61 86.403 90.803 62.254 90.803 62.254L96.468 77.46C96.468 77.46 97.068 89.982 97.661 91.771C98.254 93.56 97.061 96.84 99.152 97.138C101.243 97.436 103.624 95.647 104.817 95.051C106.01 94.455 103.028 94.451 103.624 94.157C104.22 93.863 106.009 92.964 105.413 92.666C104.817 92.368 104.22 78.057 104.22 78.057C104.22 78.057 102.58 47.496 100.493 46.304C99.9203 45.9791 99.2444 45.8874 98.6058 46.0479C97.9672 46.2085 97.415 46.6089 97.064 47.166L80.669 50.332Z",
    fill: "#11376A"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0362 95.649V98.0341C86.0362 98.0341 83.3532 104.518 86.0362 104.518C88.7192 104.518 90.8062 105.19 90.8062 104.295V96.2451L86.0362 95.649Z",
    fill: "#1897CD"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M103.63 95.645V98.03C103.63 98.03 106.313 104.514 103.63 104.514C100.947 104.514 98.8599 105.186 98.8599 104.291V96.241L103.63 95.645Z",
    fill: "#1897CD"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2718 13.2101C91.2359 13.2101 93.6388 10.8072 93.6388 7.84307C93.6388 4.87896 91.2359 2.47607 88.2718 2.47607C85.3077 2.47607 82.9048 4.87896 82.9048 7.84307C82.9048 10.8072 85.3077 13.2101 88.2718 13.2101Z",
    fill: "#A0616A"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6329 17.8311C86.6329 17.8311 88.1239 22.3031 90.5089 21.4091L92.8939 20.5151L97.0679 49.1381C97.0679 49.1381 93.7879 53.9081 89.0179 50.9271C84.2479 47.9461 86.6329 17.8311 86.6329 17.8311Z",
    fill: "#11376A"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8071 16.937L92.1491 14.105C92.1491 14.105 100.049 17.832 101.243 19.024C101.982 19.845 102.405 20.9019 102.436 22.006L100.349 29.46C100.349 29.46 100.949 45.86 100.949 46.455C100.949 47.05 103.036 50.331 101.549 49.138C100.062 47.945 99.7601 46.753 98.5671 48.538C97.4428 49.9874 96.1405 51.2897 94.6911 52.414L90.8071 16.937Z",
    fill: "#1897CD"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M101.242 38.4031L100.348 46.7511C100.348 46.7511 94.981 51.5211 96.174 51.8201C96.5289 51.8875 96.8962 51.8365 97.2194 51.675C97.5425 51.5135 97.8038 51.2504 97.963 50.9261C97.963 50.9261 100.05 53.0131 101.243 51.8201C102.436 50.6271 105.414 39.2981 105.414 39.2981L101.242 38.4031Z",
    fill: "#A0616A"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3858 0.258002C87.1986 0.0984753 85.9909 0.299876 84.9198 0.836005C84.4575 1.15771 84.052 1.55412 83.7198 2.009C82.7428 3.244 81.8988 4.798 82.2618 6.33L82.6838 6.16601C82.6838 6.57485 82.593 6.97858 82.4178 7.34801C82.4768 7.17501 82.6758 7.454 82.6178 7.629L82.1538 9.15201C82.3456 9.09286 82.5478 9.07466 82.7471 9.09857C82.9465 9.12248 83.1385 9.18798 83.3109 9.29082C83.4833 9.39366 83.6322 9.53155 83.7479 9.69558C83.8637 9.8596 83.9437 10.0461 83.9828 10.243C84.0358 8.474 84.2198 6.443 85.6548 5.409C86.42 4.94274 87.283 4.66066 88.1758 4.58501C88.9793 4.38973 89.8183 4.39385 90.6198 4.59701C91.0163 4.71054 91.3602 4.95985 91.5915 5.30133C91.8227 5.64281 91.9266 6.05471 91.8848 6.465C92.0704 6.42315 92.2648 6.44618 92.4355 6.53025C92.6062 6.61432 92.7429 6.75435 92.8228 6.927C92.9733 7.27744 93.0391 7.65841 93.0148 8.03901C93.3978 8.31001 93.8328 7.772 93.9888 7.33C94.4292 6.31603 94.5994 5.2053 94.4828 4.106C94.4099 3.55951 94.1554 3.05339 93.7602 2.66892C93.365 2.28445 92.8521 2.04394 92.3038 1.98601C92.4379 1.83948 92.5096 1.64652 92.5038 1.448L91.5968 1.371C91.8275 1.33877 92.0397 1.22701 92.1968 1.05501C91.8378 1.45801 88.9748 0.279002 88.3858 0.258002Z",
    fill: "#11376A"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1198 16.0421C88.1198 16.0421 85.6928 13.6641 84.8198 13.8091C83.9468 13.9541 82.7538 16.0421 82.7538 16.0421C82.7538 16.0421 75.5978 18.4271 75.8968 20.8121C76.1958 23.1971 79.4748 34.8251 79.4748 34.8251C79.4748 34.8251 82.1578 48.8381 79.7748 50.3251C77.3918 51.8121 91.1048 55.6921 91.4028 53.9031C91.7008 52.1141 92.2968 34.2251 91.4028 31.5421C90.5088 28.8591 88.1198 16.0421 88.1198 16.0421Z",
    fill: "#1897CD"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5581 20.812H102.245C102.245 20.812 104.82 32.142 105.118 33.334C105.416 34.526 106.012 40.191 105.718 40.191C105.424 40.191 99.4571 38.998 99.4571 39.891L98.5581 20.812Z",
    fill: "#1897CD"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4342 48.869H84.3212C82.8858 42.8514 82.8858 36.5806 84.3212 30.563H98.4342C96.0833 36.4386 96.0833 42.9934 98.4342 48.869V48.869Z",
    fill: "#F2F2F2"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M78.582 41.0869L82.756 42.8759C82.756 42.8759 90.806 44.0689 90.806 40.7889C90.806 37.5089 82.756 39.2979 82.756 39.2979L80.072 38.4399L78.582 41.0869Z",
    fill: "#A0616A"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M79.477 19.024L75.899 19.918L73.216 35.718C73.216 35.718 72.322 39.892 73.816 40.19C75.31 40.488 79.481 42.873 79.481 42.873C79.481 42.873 80.081 38.401 81.27 38.401L78.288 36.0161L80.077 25.5811L79.477 19.024Z",
    fill: "#1897CD"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8789 49.554H9.31592V49.833H28.8789V49.554Z",
    fill: "#F2F2F2"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M14.905 47.0391H14.626V49.6241H14.905V47.0391Z",
    fill: "#F2F2F2"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4289 47.0391H23.1499V49.6241H23.4289V47.0391Z",
    fill: "#F2F2F2"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7261 8.19189H16.1631V8.47089H35.7261V8.19189Z",
    fill: "#F2F2F2"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4162 8.4021H30.1372V10.9871H30.4162V8.4021Z",
    fill: "#F2F2F2"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8918 8.4021H21.6128V10.9871H21.8918V8.4021Z",
    fill: "#F2F2F2"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4292 35.72H35.8662V35.999H55.4292V35.72Z",
    fill: "#F2F2F2"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1188 35.9301H49.8398V38.5151H50.1188V35.9301Z",
    fill: "#F2F2F2"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5949 35.9301H41.3159V38.5151H41.5949V35.9301Z",
    fill: "#F2F2F2"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1719 35.5811H2.60889V35.8601H22.1719V35.5811Z",
    fill: "#F2F2F2"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M16.861 35.79H16.582V38.375H16.861V35.79Z",
    fill: "#F2F2F2"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33711 35.79H8.05811V38.375H8.33711V35.79Z",
    fill: "#F2F2F2"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M45.647 21.6071H26.084V21.8861H45.647V21.6071Z",
    fill: "#F2F2F2"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M31.673 19.092H31.394V21.677H31.673V19.092Z",
    fill: "#F2F2F2"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M40.197 19.092H39.918V21.677H40.197V19.092Z",
    fill: "#F2F2F2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomers);
export default __webpack_public_path__ + "static/media/customers.f908a920deca0184cc4a46f26f3099de.svg";
export { ForwardRef as ReactComponent };